/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Demo-template.vue?vue&type=template&id=eff9ef24&scoped=true"
import script from "./Demo-template.vue?vue&type=script&lang=js"
export * from "./Demo-template.vue?vue&type=script&lang=js"
import style0 from "./Demo-template.vue?vue&type=style&index=0&id=eff9ef24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff9ef24",
  null
  
)

export default component.exports